module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-85596f57e2780f4a9c21dc0737ca25a6.svg";